import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import {elementInViewport} from "@/utils/utils.js"

export default async () => {
      // map and station-domain apps
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCOthaijtwQIXqc-nv6DRcEuUg62DqjheY', // TODO move the keys into config
      // libraries: "places",
      map_id: "326e7548c437d85e",
    },
    installComponents: true
  })
  let throttleTimer;
  const throttleDelay = 100;

  async function initMaps() {
    const mainMapRoot = document.querySelector('#tf-map--wrapper');
    if (mainMapRoot && elementInViewport(mainMapRoot)) {
      await window.appInitializer.initMainMapApp()
      await window.appInitializer.initStationDomainApp()

      window.removeEventListener('scroll', throttledInitMaps)
    }
  }

  function throttledInitMaps() {
    clearTimeout(throttleTimer);
    throttleTimer = setTimeout(initMaps, throttleDelay);
  }

  window.addEventListener('scroll', throttledInitMaps)

}